// El ave de cada persona por su apodo (Jilguero, Zopilote, Cigüeña…): la ilustración que se usa si no eligió otro avatar.
const AVES = ["aguila", "buho", "canario", "cardenal", "carpintero", "ciguena", "cisne", "colibri", "faisan", "gaviota", "golondrina", "halcon", "jilguero", "loro", "palomo", "pinguino", "tucan", "zopilote"];
const ARCHIVO_AVE: Record<string, string> = { ciguena: "cigueña" };
/** null si el apodo no es de un ave conocida. Acepta «Apodo · Nombre». */
export function aveDe(apodo?: string | null) {
  const k = (apodo ?? "").split("·")[0].normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^a-z]/g, "");
  return AVES.includes(k) ? `/img/aves/${ARCHIVO_AVE[k] ?? k}.webp` : null;
}
